<template>
  <section class="table-sampler-result-noise table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="bg-grey text-left" style="width:15%;">Campo</th>
          <th class="text-center" style="width:42.5%">NHO 01</th>
          <th class="text-center" style="width:42.5%">NR 15</th>
        </tr>
      </thead>
      <tbody>
        <!-- Código -->
        <tr>
          <td class="bg-grey">Código</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.code" placeholder="Código NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.code" placeholder="Código NR 15" />
          </td>
        </tr>
        <!-- Agente -->
        <tr>
          <td class="bg-grey">Agente</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.agent" placeholder="Agente NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.agent" placeholder="Agente NR 15" />
          </td>
        </tr>
        <!-- Método -->
        <tr>
          <td class="bg-grey">Método</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.method" placeholder="Método NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.method" placeholder="Método NR 15" />
          </td>
        </tr>
        <!-- Resultado -->
        <tr>
          <td class="bg-grey">Resultado</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.result" placeholder="Resultado NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.result" placeholder="Resultado NR 15" />
          </td>
        </tr>
        <!-- LAVG -->
        <tr>
          <td class="bg-grey">LAVG</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.lavg" placeholder="LAVG NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.lavg" placeholder="LAVG NR 15" />
          </td>
        </tr>
        <!-- LEQ -->
        <tr>
          <td class="bg-grey">LEQ</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.leq" placeholder="LEQ NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.leq" placeholder="LEQ NR 15" />
          </td>
        </tr>
        <!-- TWA -->
        <tr>
          <td class="bg-grey">TWA</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.twa" placeholder="TWA NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.twa" placeholder="TWA NR 15" />
          </td>
        </tr>
        <!-- NEN -->
        <tr>
          <td class="bg-grey">NEN</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.nen" placeholder="NEN NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.nen" placeholder="NEN NR 15" />
          </td>
        </tr>
        <!-- Dose -->
        <tr>
          <td class="bg-grey">Dose 8h</td>
          <td>
            <input type="text" @input="setConclusion(model.nho.dose8, 'nho')" class="form-control" v-model="model.nho.dose8" placeholder="Dose 8h NHO 01" />
          </td>
          <td>
            <input type="text" @input="setConclusion(model.nr15.dose8, 'nr15')" class="form-control" v-model="model.nr15.dose8" placeholder="Dose 8h NR 15" />
          </td>
        </tr>
        <!-- Conclusão -->
        <tr>
          <td class="bg-grey">
            Conclusão
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nho.conclusion" placeholder="Conclusão NHO 01" />
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nr15.conclusion" placeholder="Conclusão NR 15" />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { NOISE } from '_modules/settings/components/SettingsModel';
import { NOISE_RESULT, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Noise',
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_RESULT),
    };
  },
  computed: {
    noiseSettings() {
      const { noise } = this.$store.state.settings.results;
      if (noise) {
        return noise;
      }
      return { ...NOISE };
    },
  },
  methods: {
    ...mapActions([
      'getSettings',
    ]),
    setModel() {
      if (this.result) {
        if (this.result.nho && this.result.nr15) {
          this.model = cloneDeep({ ...this.model, ...this.result });
        } else {
          this.model.nho = cloneDeep(this.result);
          this.model.nr15 = cloneDeep(this.result);
        }
      }
    },
    setConclusion(dose8, type) {
      const numberRegex = /[-+]?\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(\.\d+)?/g;

      if (!dose8 || !numberRegex.test(dose8)) {
        this.model[type].conclusion = null;
        this.model[type].bgColor = '#cfcfc4';
        return;
      }

      const levels = Object.entries(this.noiseSettings[type]);
      const matchingEntry = this.findLevelMatch(dose8, levels);

      if (matchingEntry) {
        const [matchingKey, matchingLevel] = matchingEntry;
        this.model[type].conclusion = matchingLevel ? matchingLevel.technicalConsiderations : null;
        this.model[type].bgColor = this.noiseSettings[type][matchingKey].bgColor || '#cfcfc4';
      }
    },
    findLevelMatch(dose8, levels) {
      const doseValue = this.convertToNumber(dose8);

      return levels.find(level => {
        const min = level[1].dailyDoseMin ? this.convertToNumber(level[1].dailyDoseMin) : -Infinity;
        const max = level[1].dailyDoseMax ? this.convertToNumber(level[1].dailyDoseMax) : Infinity;
        return doseValue >= min && doseValue < max;
      });
    },
    convertToNumber(value) {
      if (value) {
        const number = parseFloat(value.toString().replace(/,/g, '.'));
        if (!Number.isNaN(number) && number !== 0) {
          return number;
        }
      }
      return null;
    },
  },
  mounted() {
    this.getSettings()
      .then(() => this.setModel());
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: middle;
}

input {
  min-width: 150px;
}

</style>
